export {};
//# sourceMappingURL=IXDomainRequest.js.map